import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.old.EmailPinLogin', this, 2);
        tmp0_serialDesc.a1b('email', false);
        tmp0_serialDesc.a1b('pin', false);
        this.a4e_1 = tmp0_serialDesc;
      }
      b4e(encoder, value) {
        var tmp0_desc = this.a4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.c4e_1);
        tmp1_output.a15(tmp0_desc, 1, value.d4e_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b4e(encoder, value instanceof EmailPinLogin() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return EmailPinLogin().e4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.a4e_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var EmailPinLoginClass;
function EmailPinLogin() {
  if (EmailPinLoginClass === VOID) {
    class $ {
      toString() {
        return 'EmailPinLogin(email=' + this.c4e_1 + ', pin=' + this.d4e_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.c4e_1);
        result = imul(result, 31) + getStringHashCode(this.d4e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmailPinLogin()))
          return false;
        if (!(this.c4e_1 === other.c4e_1))
          return false;
        if (!(this.d4e_1 === other.d4e_1))
          return false;
        return true;
      }
      static e4e(seen0, email, pin, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance().a4e_1);
        }
        var $this = createThis(this);
        $this.c4e_1 = email;
        $this.d4e_1 = pin;
        return $this;
      }
    }
    initMetadataForClass($, 'EmailPinLogin', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    EmailPinLoginClass = $;
  }
  return EmailPinLoginClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.old.PhonePinLogin', this, 2);
        tmp0_serialDesc.a1b('phone', false);
        tmp0_serialDesc.a1b('pin', false);
        this.f4e_1 = tmp0_serialDesc;
      }
      g4e(encoder, value) {
        var tmp0_desc = this.f4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.h4e_1);
        tmp1_output.a15(tmp0_desc, 1, value.i4e_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.g4e(encoder, value instanceof PhonePinLogin() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.f4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PhonePinLogin().j4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.f4e_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var PhonePinLoginClass;
function PhonePinLogin() {
  if (PhonePinLoginClass === VOID) {
    class $ {
      toString() {
        return 'PhonePinLogin(phone=' + this.h4e_1 + ', pin=' + this.i4e_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.h4e_1);
        result = imul(result, 31) + getStringHashCode(this.i4e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PhonePinLogin()))
          return false;
        if (!(this.h4e_1 === other.h4e_1))
          return false;
        if (!(this.i4e_1 === other.i4e_1))
          return false;
        return true;
      }
      static j4e(seen0, phone, pin, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().f4e_1);
        }
        var $this = createThis(this);
        $this.h4e_1 = phone;
        $this.i4e_1 = pin;
        return $this;
      }
    }
    initMetadataForClass($, 'PhonePinLogin', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    PhonePinLoginClass = $;
  }
  return PhonePinLoginClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.auth.old.PasswordLogin', this, 2);
        tmp0_serialDesc.a1b('username', false);
        tmp0_serialDesc.a1b('password', false);
        this.k4e_1 = tmp0_serialDesc;
      }
      l4e(encoder, value) {
        var tmp0_desc = this.k4e_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.m4e_1);
        tmp1_output.a15(tmp0_desc, 1, value.n4e_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l4e(encoder, value instanceof PasswordLogin() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.k4e_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.v13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return PasswordLogin().o4e(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.k4e_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var PasswordLoginClass;
function PasswordLogin() {
  if (PasswordLoginClass === VOID) {
    class $ {
      toString() {
        return 'PasswordLogin(username=' + this.m4e_1 + ', password=' + this.n4e_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.m4e_1);
        result = imul(result, 31) + getStringHashCode(this.n4e_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PasswordLogin()))
          return false;
        if (!(this.m4e_1 === other.m4e_1))
          return false;
        if (!(this.n4e_1 === other.n4e_1))
          return false;
        return true;
      }
      static o4e(seen0, username, password, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_1().k4e_1);
        }
        var $this = createThis(this);
        $this.m4e_1 = username;
        $this.n4e_1 = password;
        return $this;
      }
    }
    initMetadataForClass($, 'PasswordLogin', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    PasswordLoginClass = $;
  }
  return PasswordLoginClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instanceoexmrian6dpx,
  Companion_instance_1 as Companion_instance3pds0w11gibwr,
  Companion_instance_0 as Companion_instance1d4dbx3jji78w,
};
//endregion

//# sourceMappingURL=EmailPinLogin.mjs.map
